import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// Date configuration is handled by shared/date-fns.ts
import App from './App'
import { AuthProvider } from '@/frontend/contexts/AuthContext'
import { CompanyProvider } from '@/frontend/contexts/CompanyContext'

// Main app root
const rootElement = document.getElementById('root')
if (rootElement) {
	createRoot(rootElement).render(
		<StrictMode>
			<AuthProvider>
				<CompanyProvider>
					<App />
				</CompanyProvider>
			</AuthProvider>
		</StrictMode>
	)
}

